<!-- 偏好教练推荐：仅App展示，筛选时段或非会籍城市时由父级隐藏 -->
<template>
  <div class="recommend-coach" v-if="list && list.length && !hidden">
    <div class="rc-scroll">
      <template v-for="(item, index) in list">
        <div
          :key="index"
          class="rc-card"
          @click="onCardClick(item)"
          v-if="item.show_txt"
        >
          <div class="rc-img">
            <img
              class="img"
              :src="
                (item.image || '') +
                '?x-oss-process=image/resize,m_fill,h_200,w_200'
              "
              alt=""
            />
          </div>
          <div class="rc-info">
            <div class="i-name"
              >{{ item.name }}
              <div class="i-shop">{{
                item.shopname || item.shop_name
              }}</div></div
            >
            <div class="i-txt">
              {{ getShowTxt(item) }}
            </div>
          </div>
          <div class="rc-tag">偏好教练</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendCoach',

  components: {},

  props: {
    // 当前日期对象（需含 a_day，格式 YYYY-MM-DD）
    day: {
      type: Object,
      default: () => ({})
    },
    // 是否隐藏（父级按 筛选时段/非会籍城市 控制）
    hidden: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      list: [], // 推荐教练列表
      cache: new Map() // 按日期缓存请求结果，避免同日重复请求
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    }
  },

  watch: {
    day(nv) {
      if (nv && nv.a_day) this.loadRecommend()
    },
    hidden(nv) {
      // 由隐藏切换为展示时重新请求
      if (!nv) this.loadRecommend()
    }
  },

  created() {
    this.loadRecommend()
  },

  destroyed() {},

  methods: {
    // 请求推荐教练数据
    async loadRecommend() {
      if (this.hidden) return
      if (!this.day || !this.day.a_day) return
      const dayKey = this.day.a_day
      // 同日不重复请求，直接使用缓存数据
      if (this.cache.has(dayKey)) {
        this.list = this.cache.get(dayKey)
        return
      }
      const res = await this.$http.get(
        'member/AppEntrance?a=userCoachRecommendByApp',
        { day: dayKey, is_h5: '1' }
      )
      if (res.data.code === 200 && Array.isArray(res.data.data)) {
        this.list = res.data.data // 正式数据
        this.cache.set(dayKey, this.list)
        // 有数据时上报曝光埋点（from_id 待埋点配置确认后替换）
        if (this.list.length) {
          this.$http.get('member/index?a=shareLogPush', {
            from: `偏好教练推荐-曝光-app`,
            from_id: 260707001
          })
        }
      }
    },
    /**
     * 强制刷新推荐教练数据（清除缓存后重新请求）
     * 用于偏好设置保存后重新获取
     */
    refreshRecommend() {
      if (this.day && this.day.a_day) {
        this.cache.delete(this.day.a_day)
        this.list = []
        this.loadRecommend()
      }
    },
    // 是否为「可约时段」类型
    isTimeType(item) {
      return item.show_txt && item.show_txt.type === 2
    },
    // 根据 show_txt 组装展示文案
    // type=1 显示可约节数；type=2 显示可约时间
    getShowTxt(item) {
      const st = item.show_txt
      if (!st) return ''
      if (st.type === 1) {
        return `待约课时：${st.num}节`
      } else if (st.type === 2) {
        return `${st.time} 可约`
      }
      return ''
    },
    // 点击教练卡片 → 走中转页进入教练约课主页
    onCardClick(item) {
      this.$router.push({
        path: '/trans-coach-course',
        query: {
          coachid: item.id || item.coachid,
          day: this.day.a_day
        }
      })
      this.$http.get('member/index?a=shareLogPush', {
        from: `偏好教练推荐-点击教练卡片-app`,
        from_id: 260707002
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.recommend-coach {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;

  .rc-scroll {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 16px;
    padding-top: 12px; // 为 tag 预留空间

    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }

    .rc-card {
      flex-shrink: 0;
      width: vw(200);
      height: vw(48);
      box-sizing: border-box;
      padding-left: 8px;
      background: linear-gradient(189deg, #f9f9f9 0%, #f9f9f9 99.92%);
      border: 1px solid #f1f1f1;
      border-radius: vw(4);
      display: flex;
      position: relative;

      &:not(:last-child) {
        margin-right: vw(10);
      }

      .rc-img {
        flex-shrink: 0;
        margin-top: 6px;
        .img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-color: #d8d8d8;
          object-fit: cover;
          display: block;
        }
      }

      .rc-info {
        flex: 1;
        min-width: 0;
        margin-left: 8px;
        margin-top: 8px;

        .i-name {
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          color: #000;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;

          .i-shop {
            flex: 1;
            min-width: 0;
            font-size: 10px;
            line-height: 14px;
            color: rgba(0, 0, 0, 0.5);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 6px;
          }
        }

        .i-txt {
          font-size: 10px;
          color: #ff2270;
          font-weight: 500;
          margin-top: 1px;
        }
      }

      .rc-tag {
        width: 52px;
        height: 16px;
        background: #ff2270;
        border-radius: 10px;
        font-weight: 500;
        font-size: 9px;
        color: #ffffff;
        position: absolute;
        right: 0;
        top: -8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
